import { useCheckout } from '../../../../../hooks/use-checkout';
import { usePaymentState } from '../../../hooks/use-payment-state';
import { useShowTaxCalculationFields } from '../../../hooks/use-show-tax-calculation-fields';

export function useShouldBlockExpressCheckoutButtons() {
  const { checkoutData } = useCheckout();
  const { useTaxCalculationField, showAddressField } = useShowTaxCalculationFields();
  const isZipCodeValidatedOnce = usePaymentState((state) => state.isZipCodeValidatedOnce);

  if (!useTaxCalculationField) {
    return {
      shouldBlockExpressCheckoutButtons: false,
    };
  }

  if (showAddressField) {
    return {
      shouldBlockExpressCheckoutButtons:
        !checkoutData?.customer.address?.zipCode && !isZipCodeValidatedOnce,
    };
  }

  return {
    shouldBlockExpressCheckoutButtons:
      !checkoutData?.customer.address?.zipCode && !isZipCodeValidatedOnce,
  };
}
